import { settings } from '@/main/config/settings'

/**
 * LaunchDarkly configuration
 * Initializes with an anonymous user context to ensure flags are ready immediately
 */
export default {
  clientSideID: settings.LAUNCH_DARKLY_CLIENT_ID,
  context: {
    kind: 'user',
    key: '00000000-0000-0000-0000-000000000000',
    anonymous: true
  },
  options: {
    bootstrap: 'localStorage' as const,
    streaming: true,
    evaluationReasons: true
  },
  // Provider não assina nenhuma flag → não re-renderiza a árvore a cada `change` do stream.
  // Sem isso, o asyncWithLDProvider assina TODAS as flags e re-renderiza tudo abaixo dele no
  // instante da mudança (mostrando loading / disparando requests), independente do jitter.
  // Os valores continuam lidos via useLDClient().variation() (useFeatureFlags + getFlagValue),
  // e os listeners `change:flagKey` do useFeatureFlags continuam disparando.
  // Seguro: nenhum componente usa useFlags() do SDK.
  flags: {},
  reactOptions: {
    useCamelCaseFlagKeys: false
  }
}
